import { render, staticRenderFns } from "./AIOption.vue?vue&type=template&id=92fb04ca&scoped=true&"
import script from "./AIOption.vue?vue&type=script&lang=js&"
export * from "./AIOption.vue?vue&type=script&lang=js&"
import style0 from "./AIOption.vue?vue&type=style&index=0&id=92fb04ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fb04ca",
  null
  
)

export default component.exports